/**
 * AddressesProvider
 * Contain most logic handing with Omnitech Api
 */

import React, { useEffect, useState } from 'react'
import getAllDataInParallel from '../../helpers/get-all-data-in-parallel'
import { cancelRequest } from '../../helpers'
import { useSystemSettings } from '../../system-settings'
import AddressesContext from './addresses-context'
import {
  fetchCountries,
  fetchStatesCitiesDistricts,
  fetchStreet,
  fetchZip,
} from './addresses-api'

export default function AddressesProvider({ children }) {
  const [countryCallingCodes, setCountryCallingCodes] = useState([])
  const { getSystemSetting } = useSystemSettings()
  const extraParams = getSystemSetting('api.v2.addresses.countries.general.ecom.query')
  function fetchCountriesAll(params) {
    return getAllDataInParallel({
      fn: (args) => fetchCountries({
        ...params,
        ...args,
      }),
      key: 'countries',
    })
  }

  /**
   * handleFetchCountryCallingCodes
   */
  async function handleFetchCountryCallingCodes() {
    try {
      // start refreshing cache data
      const { countries: data } = await fetchCountriesAll({
        params: extraParams,
        // arrayFormat: 'brackets',
      })
      setCountryCallingCodes(_.map(data, 'callingCode'))
    } catch (error) {
      console.warn('fail to refresh brands for cache', error)
    }
  }

  /**
   * get all countries from omnitech API when app is mounted
   */
  useEffect(() => {
    handleFetchCountryCallingCodes()
    return function cleanUp() {
      cancelRequest.cancelAll(['fetchCountries'])
    }
  }, [])

  return (
    <AddressesContext.Provider
      value={{
        countryCallingCodes,
        fetchCountries,
        fetchStatesCitiesDistricts,
        fetchStreet,
        fetchZip
      }}
    >
      {children}
    </AddressesContext.Provider>
  )
}
